import { ITheme } from "../../utils/theme";

export const selectStyle = {
  margin: "8px 2px",
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      padding: "10px 15px",
    }
  }
}

export const selectMenuStyle = {
  maxHeight: { xs: 300, sm: 400, md: 500 }
}

export const placeholderStyle = {
  color: (theme: ITheme) => theme.palette.grey[400]
}

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}